import styles from "@/app/css/app-btn.module.css";
import React from "react";
import {AppTag} from "@/app/components/common/app-tag/AppTag";
import {cn} from "@/lib/utils";
import {useTranslations} from "next-intl";

interface IProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    icon?: React.ReactNode;
    label: string;
    appendIcon?: React.ReactNode;
    active?: boolean;
    soon?: boolean;
}

export const AppBtn = ({icon, label, appendIcon, soon, active, className, ...props}: IProps) => {
    const t = useTranslations();
    return (
        <button
            disabled={soon}
            className={cn('bg-transparent w-[240px] h-[40px] flex items-center justify-between cursor-pointer rounded-[8px] text-noble-black-300 px-[12px]', styles.Button, {[styles.ButtonActive]: active}, className)}
            {...props}
        >
            <span className={'flex items-center'}>
                {icon}
                <span className={cn('font-medium text-[14px]', {['ml-2']: !!icon})}>{label}</span>
            </span>
            {appendIcon || soon && <AppTag>{t('AppBtn.soon')}</AppTag>}
        </button>
    )
}
